class IconsAsTabs {
	currentIndex = 0;

	constructor(el) {
		if (!el) return;

		this.el = el;
		this.triggers = [...el.querySelectorAll('.wp-block-embark-icons-as-tabs__trigger')];
		this.panels = [...el.querySelectorAll('.wp-block-embark-icons-as-tabs__panel')];
		this.accordionTriggers = [...el.querySelectorAll('.wp-block-embark-icons-as-tabs__accordion-trigger')];

		this.triggers.forEach((trigger) => {
			trigger.addEventListener('click', () => this.open(trigger));
			trigger.addEventListener('keydown', this.handleKeydown);
		});

		this.accordionTriggers.forEach((trigger) => {
			trigger.addEventListener('click', () => this.toggleAccordion(trigger));
		});

		if (this.isAccordionMode()) {
			this.panels.forEach((p) => p.classList.remove('is-active'));
			this.accordionTriggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
		}
	}

	isAccordionMode = () => {
		return this.accordionTriggers[0] && getComputedStyle(this.accordionTriggers[0]).display !== 'none';
	};

	open = (trigger, setFocus = true) => {
		const panelId = trigger.getAttribute('aria-controls');
		const panel = document.getElementById(panelId);

		if (!panel) return;

		const activeTrigger = this.el.querySelector('.wp-block-embark-icons-as-tabs__trigger[aria-selected="true"]');
		if (activeTrigger) {
			this.close(activeTrigger);
		}

		panel.classList.add('is-active');
		trigger.setAttribute('aria-selected', 'true');
		trigger.setAttribute('tabindex', '0');

		this.currentIndex = this.triggers.indexOf(trigger);

		if (setFocus) {
			trigger.focus();
		}
	};

	close = (trigger) => {
		const panelId = trigger.getAttribute('aria-controls');
		const panel = document.getElementById(panelId);

		if (panel) {
			panel.classList.remove('is-active');
		}

		trigger.setAttribute('aria-selected', 'false');
		trigger.setAttribute('tabindex', '-1');
	};

	toggleAccordion = (accordionTrigger) => {
		const panel = accordionTrigger.closest('.wp-block-embark-icons-as-tabs__panel');
		if (!panel) return;

		const isOpen = panel.classList.contains('is-active');

		this.panels.forEach((p, i) => {
			p.classList.remove('is-active');
			this.accordionTriggers[i]?.setAttribute('aria-expanded', 'false');
		});

		if (!isOpen) {
			panel.classList.add('is-active');
			accordionTrigger.setAttribute('aria-expanded', 'true');
		}
	};

	handleKeydown = (e) => {
		let flag = false;

		switch (e.key) {
			case 'ArrowRight':
				this.open(this.triggers[(this.currentIndex + 1) % this.triggers.length]);
				flag = true;
				break;

			case 'ArrowLeft':
				this.open(this.triggers[(this.currentIndex - 1 + this.triggers.length) % this.triggers.length]);
				flag = true;
				break;

			case 'Home':
				this.open(this.triggers[0]);
				flag = true;
				break;

			case 'End':
				this.open(this.triggers[this.triggers.length - 1]);
				flag = true;
				break;

			default:
				break;
		}

		if (flag) {
			e.stopPropagation();
			e.preventDefault();
		}
	};
}

document.addEventListener('DOMContentLoaded', () => {
	[...document.querySelectorAll('.wp-block-embark-icons-as-tabs')].forEach((el) => new IconsAsTabs(el));
});
